import React, { useContext } from 'react';
import styles from './shCourseFull.card.module.scss';
import ShImage from "../../components/image/shImage";


import PropTypes from 'prop-types';
import { AuthContext } from "../../provider/authProvider";
import {
    isCourseComing2023, isCourseComing2024,
    isCourseComingSoon
} from "../../helper/course/course-helper";
import ShButton from "../../components/button/shButton";

const ShCourseFullCard = ( { course, className = '' } ) => {

    if (!course){
        return null;
    }

    const authContext = useContext(AuthContext);

    return <div className={styles.shCourseFullCard + ' border-radius h-100 p-relative ' + className}
        onClick={ () => { authContext.navigateToCourse(course) } }
    >
        <div className={styles.card}>
                <div className={styles.background}>
                    <ShImage url={course.cardThumbnailTeaser?.url ? course.cardThumbnailTeaser.url : course.teaserImage?.url} fluid={true} fullWidth={true} coverFit={true} />
                </div>

                { isCourseComingSoon(course) &&
                    <div className={styles.badgeWrapper}>
                        <div className="badge">
                            Coming Soon
                            { isCourseComing2023(course) && " 2023" }
                            { isCourseComing2024(course) && " 2024" }
                        </div>
                    </div>
                }

                <div className={styles.backgroundGradient} />

                <div className={styles.content + ' d-flex align-items-center p-4'}>

                    <div className={"text-left"}>
                        <p className="h6">{course.title}</p>
                        {course.source === "Doku" ?
                            <p className="small-text">eine Dokumentation von David Seitz</p>
                            :
                            <p className="small-text">mit {course.cook?.name}</p>
                        }
                    </div>

                </div>
        </div>
        <div className={"p-absolute d-flex h-100 w-100 align-items-center justify-content-center " + styles.hoverInfo}>
            <ShButton variant="dark" size={"small"} className={"mx-auto"}>
                zum Kurs
            </ShButton>
        </div>
    </div>;
};

ShCourseFullCard.propTypes = {
    course: PropTypes.object.isRequired,
};

export default ShCourseFullCard;
